import React from "react";
import { Link } from "react-scroll";
import TypeWriterEffect from "react-typewriter-effect";
import Fade from "react-reveal/Fade";
import "./About.scss";
import { isFeatureEnabled } from "utils/utils";
import SocialData from "data/socialdata.json";

const About = () => {
  const isShowGradient = isFeatureEnabled("SHOW_RADIAL_BLUR");
  const socialDataWithId = SocialData.map((data, index) => ({
    id: index + 1,
    ...data,
  }));

  return (
    <section className="section-separator" id="about">
      <div className="content mb-5">
        <div className="row align-items-center">
          <Fade>
            <div className="col-lg-7 order-2 order-lg-1 pt-5">
              <div className="inner">
                <span className="subtitle">Hello There !</span>
                <h1 className="title">
                  I&apos;m <span>Nandun</span>
                  <br />
                  <span className="header-caption" id="page-top">
                    <div className="typewriter d-flex">
                      <span>a &nbsp;</span>

                      <TypeWriterEffect
                        textStyle={{
                          fontFamily: "Montserrat, sans-serif",
                          fontWeight: 700,
                        }}
                        startDelay={1000}
                        cursorColor="var(--color-secondary)"
                        multiText={[
                          "Web Developer.",
                          "UI/UX Designer.",
                          "Public Speaker.",
                          "Photographer.",
                          "Blogger.",
                          "Human :)",
                        ]}
                        multiTextDelay={1000}
                        typeSpeed={25}
                        multiTextLoop={true}
                      />
                    </div>
                  </span>
                </h1>
                <p className="description">
                  A passionate <span>full-stack developer</span> with a focus on
                  software development, design and cloud computing. Whether you
                  need a simple website or a complex application, I'm here to
                  help bring your ideas to life. Let's work together to create
                  something amazing!
                </p>
                <div className="social-links mt-5">
                  {socialDataWithId.map((social) => (
                    <a
                      key={social.id}
                      href={social.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social.label}
                    >
                      <i className={social.icon}></i>
                    </a>
                  ))}
                </div>
                <div className="mt-5">
                  <Link to="contact" href="contact">
                    <button className="btn-main">
                      Contact Me &nbsp;<i className="bi bi-chevron-right"></i>
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </Fade>

          <Fade>
            <div className="col-lg-5 order-1 order-lg-2">
              <div className="thumbnail">
                {isShowGradient && <div className="radial-blur" />}
                <div className="inner">
                  <img
                    className="img-fluid"
                    src="https://i.ibb.co/2M6RmY8/profile-1.webp"
                    width="420"
                    alt="Nandun Diaz"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </section>
  );
};

export default About;
